type TFields = {
  [key: string]: { value: any; [key: string]: any };
};

const rcFormStateToKeyValue = (stateFields: TFields) => {
  const fields: { [key: string]: any } = {};
  Object.keys(stateFields).forEach(key => {
    fields[key] = stateFields[key].value;
  });

  return fields;
};

export default rcFormStateToKeyValue;
